var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "variant-picker-wrapper" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c("b-pagination", {
            attrs: {
              size: "md",
              "per-page": _setup.productPerPage,
              "total-rows": _setup.totalCount,
            },
            on: { change: _setup.onFilterChange },
            model: {
              value: _setup.currentPage,
              callback: function ($$v) {
                _setup.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-3 ml-3",
            attrs: { placeholder: "Search", debounce: "400" },
            on: {
              update: function ($event) {
                return _setup.onFilterChange(1)
              },
            },
            model: {
              value: _setup.searchVal,
              callback: function ($$v) {
                _setup.searchVal = $$v
              },
              expression: "searchVal",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.SelectTable, {
        attrs: { fields: _setup.tableFields, items: _setup.filteredItems },
        on: { "item-selected": _setup.onVariantSelected },
        scopedSlots: _vm._u([
          {
            key: "cell(actions)",
            fn: function (row) {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-turquise",
                    on: { click: row.toggleDetails },
                  },
                  [_vm._v("Show Details")]
                ),
              ]
            },
          },
          {
            key: "row-details",
            fn: function ({ item }) {
              return [
                _c(
                  "b-card",
                  { staticClass: "py-3", attrs: { "no-body": "" } },
                  [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c(
                        "ul",
                        { staticClass: "col-6 m-0 pl-5" },
                        _vm._l(item.options, function (option, idx) {
                          return _c("li", { key: `${option}-${idx}` }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "font-weight-bold text-capitalize mr-1",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _setup.formattedOptionName(option.name)
                                    ) +
                                    ":\n                            "
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(option.value) +
                                "\n                        "
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      item.image
                        ? _c(
                            "div",
                            { staticClass: "col-6 text-right pr-5" },
                            [
                              _c("b-img", {
                                attrs: {
                                  rounded: "",
                                  thumbnail: "",
                                  height: "120",
                                  width: "120",
                                  src: item.image,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c(
          "button",
          { staticClass: "btn btn-secondary", on: { click: _setup.cancel } },
          [_vm._v("Back")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: !_setup.selectedVariant },
            on: { click: _setup.variantSelected },
          },
          [_vm._v("Select")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }